import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import SummerSchoolBar2026 from "../components/SummerSchool/SummerSchoolBar2026";

function SummerSchoolBar2026Page() {
  return (
    <>
      <Navbar />
      <SummerSchoolBar2026 />
      <Footer />
    </>
  );
}

export default SummerSchoolBar2026Page;
